import React from 'react'
import { rem } from 'polished'
import cn from 'clsx'
import styled from 'styled-components'
import { mediaQueryUp } from 'components/utils/breakpoint'
import LayoutContainer from 'components/Common/LayoutContainer'

const ActionFooter = styled.div`
  display: flex;
  flex-direction: column;
  margin-top: ${rem(24)};
  padding: 0 ${rem(16)};

  ${mediaQueryUp.desktop} {
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
    padding: 0;
  }
`

const StickyActionFooter = styled.div`
  bottom: -${rem(80)};
  transition: bottom 0.2s;

  &.showStickyFooter {
    display: flex;
    align-items: center;
    position: sticky;
    bottom: 0;
    background-color: ${props => props.theme.palette.neutral.eight};
    box-shadow: ${({ theme }) => theme.shadow.top.small};
    border-top: 1px solid ${props => props.theme.palette.neutral.five};
    padding: 0 ${rem(16)};
    height: ${rem(80)};
    z-index: 1;

    ${mediaQueryUp.desktop} {
      position: fixed;
      left: 0;
      width: 100%;
      padding: 0;
    }
  }
`

const StickyActionFooterContent = styled(LayoutContainer)`
  display: none;

  &.showStickyFooter {
    display: flex;
    flex-direction: column;
    padding: 0;

    ${mediaQueryUp.desktop} {
      flex-direction: row;
      justify-content: space-between;
      align-items: center;
    }
  }
`

interface Props {
  children: React.ReactNode;
  footerRef: (node?: Element) => void;
  footerInView: boolean;
  reviewPageInView: boolean;
}

function MultipleRoomsBookingContentFooter(props: Props) {
  const { children, footerRef, footerInView, reviewPageInView } = props

  return (
    <>
      <ActionFooter ref={footerRef}>
        {children}
      </ActionFooter>
      <StickyActionFooter className={cn({ showStickyFooter: !footerInView && reviewPageInView })}>
        <StickyActionFooterContent className={cn({ showStickyFooter: !footerInView && reviewPageInView })}>
          {children}
        </StickyActionFooterContent>
      </StickyActionFooter>
    </>
  )
}

export default MultipleRoomsBookingContentFooter
